import { graphql } from "relay-runtime"

export const deUpdatePatientFamilyHistoryMutation = graphql`
  mutation deUpdatePatientFamilyHistoryMutation($input: De_updatePatientFamilyHistoryInput!) {
    updatePatientFamilyHistory: de_updatePatientFamilyHistory(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      familyHistory {
        ...FamilyHistoryFragment
      }
    }
  }
`
